import { render, staticRenderFns } from "./airConfigSet.vue?vue&type=template&id=35bd6c22&scoped=true"
import script from "./airConfigSet.vue?vue&type=script&lang=ts"
export * from "./airConfigSet.vue?vue&type=script&lang=ts"
import style0 from "./airConfigSet.vue?vue&type=style&index=0&id=35bd6c22&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd6c22",
  null
  
)

export default component.exports